<template>
  <div>
    <b-modal
      size="lg"
      :title="$t('modal.booking_requests.title_booking_addons', {
        id: selectedObject.id
      })"
      :id="modalId"
      ok-only
      :no-enforce-focus="true"
      :ok-title="$t('modal.general.ok_button')">
      <div>
        <content-table
          head-variant="dark"
          :primaryKey="primaryKey"
          :fields="fields"
          :items="bookingAddonsItems"
          :defaultSlots="defaultSlots"
          :defaultSortBy="sortBy"
          :defaultSortDesc="sortDesc"
        >
          <template slot="bottom-row" v-if="bookingAddonsItems.length">
          <td class="text-center font-weight-bold bg-light-blue">{{ $t('table.booking_addons.title_total') }}</td>
          <td class="text-center font-weight-bold bg-light-blue"></td>
          <td class="text-center font-weight-bold bg-light-blue"></td>
          <td class="text-center font-weight-bold bg-light-blue">{{ formatNumber(getTotal(bookingAddonsItems, 'quantity'), { precision: 2, marketCountry: market?.supportCountry?.code }) }}</td>
          <td class="text-center font-weight-bold bg-light-blue">{{ formatNumber(getTotal(bookingAddonsItems, 'totalPrice'), { precision: 2, marketCountry: market?.supportCountry?.code }) }}</td>
        </template>
        </content-table>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import ContentTable from '@base/components/ContentTable.vue'
  import Formatting from '@base/mixins/Formatting'
  import ObjectUtils from '@base/mixins/ObjectUtils.vue'
  import TableUtils from "@base/mixins/TableUtils.vue";


  export default {
    name: 'BookingAddonsModal',

    components: {
      ContentTable
    },

    mixins: [ Formatting, ObjectUtils, TableUtils ],

    data () {
      return {
        primaryKey: 'lineItem',
        sortBy: 'lineItem',
        sortDesc: false,
        fields: [
          { key: 'lineItem', label: this.$t('table.booking_addons.line_item'), class: 'text-center', sortable: true },
          { key: 'serviceName', label: this.$t('table.booking_addons.service_name'), class: 'text-center', sortable: true },
          { key: 'unitPrice', label: this.$t('table.booking_addons.unit_price'), class: 'text-center' },
          { key: 'quantity', label: this.$t('table.booking_addons.quantity'), class: 'text-center' },
          { key: 'totalPrice', label: this.$t('table.booking_addons.total_price'), class: 'text-center', sortable: true },
        ],
        defaultSlots: [
          { name: 'bottom-row' }
        ],
      }
    },

    props: {
      modalId: {
        type: String,
        required: true
      },
      selectedObject: {
        type: Object,
        required: true
      },
      market: {
        type: Object,
        required: true
      },
      bookingAddonsData: {
        type: Array,
        required: true
      }
    },

    computed: {
      bookingAddonsItems() {

        const rows = [];

        // 1. Main booking row
        rows.push({
          lineItem: 1,
          id: this.selectedObject.id,
          serviceName: this.$t('table.booking_requests.booking_label'),
          quantity: 1,
          unitPrice: this.selectedObject.discountedPrice,
          totalPrice: this.selectedObject.discountedPrice,
        });

        // 2. Additional services
        this.bookingAddonsData.forEach((addon, index) => {
          rows.push({
            lineItem: index + 2, // skipping main booking request index
            serviceName: addon.serviceName || addon.service?.name || this.$t('table.booking_requests.addon_label'),
            quantity: addon.quantity,
            unitPrice: addon.unitPrice,
            totalPrice: this.formatNumber(this.parseNumber(addon.unitPrice) * addon.quantity, { precision: 2, marketCountry: this.market?.supportCountry?.code }),
          });
        });

        return rows;
      }
    },
  }
</script>

<style>

</style>
